export enum FeatureStatus {
  /** admin only feature */
  ADMIN = 'admin',
  /** placeholder feature to be implemented */
  PLANNED = 'planned',
  /** development stage */
  ALPHA = 'alpha',
  /** released for user to use */
  BETA = 'beta',
  /** stable, beta tested for a while */
  PROD = 'prod',
  /** retired, no longer maintained */
  RETIRED = 'retired',
}
